module.exports = __webpack_public_path__ + "img/about_banner.bbff81b5.jpg";